import styled from 'styled-components';
import { Form, FormItem, RangePicker } from '@/components';
import { Select } from '@/ui';
import { TreeSelect } from 'antd';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  border: 1px solid ${COLORS.GREY};
  border-radius: 0.5rem;
  background-color: ${COLORS.GRAY_LIGHT};
  min-width: 22rem;
  width: 100%;
`;

export const StyledForm = styled(Form)`
  width: 100%;
`;

export const StyledFormItem = styled(FormItem)`
  width: 100%;
  margin-bottom: 0;

  &&& .ant-form-item-label {
    padding: 0;
    label {
      ${pickThemeFontStyles('12', '14', 'NORMAL')};
      color: ${COLORS.IRON_GRAY};
    }
  }
`;

export const StyledRangePicker = styled(RangePicker)`
  width: 100%;
  min-height: 2.75rem;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  min-height: 2.75rem;
`;

export const StyledTreeSelect = styled(TreeSelect)`
  &&& {
    width: 100%;
    height: 2.75rem;
  }
` as typeof TreeSelect;

export const StyledDivider = styled.div`
  height: 1px;
  background-color: ${COLORS.GREY};
  margin: 0.25rem 0;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const StyledTh = styled.th`
  ${pickThemeFontStyles('12', '14', 'NORMAL')};
  color: ${COLORS.IRON_GRAY};
  text-align: right;
  padding: 0.375rem 0.5rem;

  &:first-child {
    text-align: left;
  }
`;

export const StyledTd = styled.td`
  ${pickThemeFontStyles('14', '18', 'NORMAL')};
  color: ${COLORS.BLACK};
  text-align: right;
  padding: 0.375rem 0.5rem;

  &:first-child {
    text-align: left;
  }
`;

export const StyledTr = styled.tr``;

export const StyledTotalTd = styled.td`
  ${pickThemeFontStyles('14', '18', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
  text-align: right;
  padding: 0.375rem 0.5rem;
  border-top: 1px solid ${COLORS.GREY};

  &:first-child {
    text-align: left;
  }
`;

export const StyledContractorsBlock = styled.div`
  border-top: 1px solid ${COLORS.GREY};
  padding-top: 0.75rem;
`;

export const StyledContractorsTitle = styled.div`
  ${pickThemeFontStyles('12', '14', 'SEMI_BOLD')};
  color: ${COLORS.IRON_GRAY};
  margin-bottom: 0.5rem;
`;

export const StyledContractorsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const StyledContractorItem = styled.li<{ $clickable: boolean }>`
  ${pickThemeFontStyles('14', '18', 'NORMAL')};
  color: ${COLORS.BLACK};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${({ $clickable }) => ($clickable ? COLORS.GREY : 'transparent')};
  }
`;

export const StyledContractorCount = styled.span`
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
  color: ${COLORS.IRON_GRAY};
  flex-shrink: 0;
  margin-left: 0.5rem;
`;
